// External libraries
import { useNavigate } from 'react-router-dom';

// CSS
import '../styles/main.css';

// Components
import { Button, ButtonTheme, ButtonSize, ButtonVariant, Heading, TypographyType, TypographyColor, Body, BodyType, BodyColor, } from '../ui-elements';

// Utilities
import { RouteConstants } from '../constants/routeConstants';
import { useUserService } from '../services';
import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { authState, geoState } from '../states';

const SomethingWentWrong = ({clienterror = false}) => {
    const navigate = useNavigate();
    const userService = useUserService();
    const setAuth = useSetRecoilState(authState);
    const setSelectedGeo = useSetRecoilState(geoState);

    useEffect(() => {
        if(clienterror) return
        localStorage.clear();
        setAuth(null);
        setSelectedGeo({ country : "EW-IN-IND-22-0" });
    }, [])

    const handleContinue = () => {
        navigate(RouteConstants.login);
    }

    const handleRefresh = () => {
        // Navigate back to the previous page in the browser history
        window.location.reload()
    };

    const handleLogout = () => {
        userService.logout();
    }

    return (
        <div style={{ width: '100vw', height: '100vh', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'start' }} >
            <div className='col-12 col-sm-12 col-md-6 col-lg-7 col-xl-7 login-update-box bg-white'>

                <div className="loginBackgroundImage">
                    <div className='position-absolute d-flex flex-column justify-content-center align-items-center' style={{ top: '67%', width: '66%' }}>
                        <Heading
                            title='EPIC Intelligence by EPIC World'
                            type={TypographyType.h4}
                            colour={TypographyColor.white}
                            classname='margin-bottom-5 fs-32 fw-bold'
                        />
                        <Heading
                            title='Welcome to EPIC Intelligence, the distribution insights product that enables companies serving Entrepreneurial Households to address the multi-trillion dollar EPIC Opportunity at scale.'
                            type={TypographyType.h5}
                            colour={TypographyColor.white}
                            classname='text-center margin-bottom-5 fs-20 line-height-1-7'
                            style={{ opacity: '70%' }}
                        />
                    </div>
                </div>
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-5 col-xl-5 login-update-box '>
                {/* <div className='errorCard d-flex flex-column justify-content-center align-items-center h-100'>
                    <div className=''>
                        <img src={ErrorState} alt="Error" style={{ height: '259px', }}></img>
                    </div>
                    <Heading
                        title='Something went wrong!'
                        type={TypographyType.h2}
                        colour={TypographyColor.primary}
                        classname='margin-bottom-2'
                    />
                    <Body
                        type={BodyType.p1}
                        color={BodyColor.secondary}
                        classname='margin-bottom-3'
                    >
                        If refreshing the page doesn't resolve the issue, please copy the link and paste it into your browser. If the problem persists, feel free to contact the administrator or send an email to ei@epicworld.com for assistance.
                    </Body>
                    <Button
                        theme={ButtonTheme.primary}
                        size={ButtonSize.large}
                        variant={ButtonVariant.bordered}
                        type='button'
                        onClick={handleContinue}
                        classname='margin-top-3 height-3rem'
                    >
                        Go to home
                    </Button>
                    <Button
                        theme={ButtonTheme.primary}
                        size={ButtonSize.large}
                        variant={ButtonVariant.transparent}
                        type='button'
                        onClick={handleRefresh}
                        classname='margin-top-3 height-3rem'
                    >
                        <u>Refresh</u>
                    </Button>
                </div> */}

                <div className="smtgwentwrongBackgroundImage">
                    <div className='position-absolute d-flex flex-column justify-content-center align-items-center' style={{ top: '62%', width: '28.42vw', }}>

                        <div className='d-flex flex-column justify-content-center align-items-center'>
                            <Heading
                                title='Something went wrong!'
                                type={TypographyType.h2}
                                colour={TypographyColor.primary}
                                classname='margin-bottom-2'
                            />
                            <Body
                                type={BodyType.p1}
                                color={BodyColor.secondary}
                                classname='margin-bottom-3 d-flex flex-column justify-content-center align-items-center'
                            // style={{textAlign:'center'}}
                            >
                                If refreshing the page doesn't resolve the issue, please copy the link and paste it into your browser. If the problem persists, feel free to contact the administrator or send an email to ei@epicworld.com for assistance.
                            </Body>
                            {!clienterror ? <Button
                                theme={ButtonTheme.primary}
                                size={ButtonSize.large}
                                variant={ButtonVariant.bordered}
                                type='button'
                                onClick={handleContinue}
                                classname='margin-top-3 height-3rem'
                            >
                                Login
                            </Button> :
                                <Button
                                    theme={ButtonTheme.primary}
                                    size={ButtonSize.large}
                                    variant={ButtonVariant.transparent}
                                    type='button'
                                    onClick={handleRefresh}
                                    classname='margin-top-3 height-3rem'
                                >
                                    <u>Refresh</u>
                                </Button>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SomethingWentWrong
